import loadScript from 'load-script';
import pify from 'pify';
import {createAction} from 'redux-actions';
import {CMS_ACTIVE_NODE_SET, CMS_DRAG_START, CMS_FETCH, CMS_NODE_MOVE} from '../action-types';

export const fetch = createAction(CMS_FETCH, cmsUrl => pify(loadScript)(`${cmsUrl}/index.js`).then(() => ({loaded: true})));
export const dragStart = createAction(CMS_DRAG_START);
export const moveNode = createAction(CMS_NODE_MOVE);
export const setActive = createAction(CMS_ACTIVE_NODE_SET, activeNode => ({activeNode}));
